import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { b } from '@angular/core/src/render3';

@Injectable()
export class ValidationProvider {
	constructor() {}

	isEmailValid(email): boolean {
		const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return pattern.test(email);
	}

	isStringEmpty(string): boolean {
		const emptyString = !string || string.trim() === '';
		return emptyString;
	}

	isStringCyrillic(string: string): boolean {
		return /[\w\u0430-\u044f]+/gi.test(string);
	}

	isStringEmptySMTP(string: string): boolean {
		if (typeof string === 'string') {
			if (string) {
				const str: string = string.trim();
				const emptyString = !str;
				return emptyString;
			}
		}
		return true;
	}

	trimHTML(html: string): string {
		const doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || '';
	}

	isModalClosePrevented(input) {
		input.on('keypress', e => {
			const keyCode = e.keyCode || e.which;

			if (keyCode === 13) {
				e.preventDefault();
			}
		});
	}

	static emailValidator(control: FormControl) {
		if (
			control.value &&
			control.value.match(
				/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			)
		) {
			return null;
		}
		return { invalidEmail: true };
	}

	static noWhitespaceValidator(control: FormControl) {
		const isWhitespace = (control.value || '').trim().length === 0;
		const isValid = !isWhitespace;
		return isValid ? null : { whitespace: true };
	}

	static numberMinMax(params = { min: 1, max: 9 }): ValidatorFn {
		return (control: AbstractControl): { [key: string]: boolean } => {
			const val: number = control.value;

			if (isNaN(val)) {
				return null;
			}

			if (val < params.min) {
				return { valid: false };
			} else if (val > params.max) {
				return { valid: false };
			}

			return { valid: true };
		};
	}

	static positiveNumberValidator(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			const isNegative = Number(control.value) < 0;
			return isNegative ? { nonPositive: { value: control.value } } : null;
		};
	}

	static decimalValidator(numbersAfterPoint = 0): ValidatorFn {
		return (control: AbstractControl): { [key: string]: boolean } => {
			const { value } = control;

			if (!value) {
				return null;
			}

			const [, decimalPart] = value.toString().split('.');

			if (!decimalPart) {
				return { valid: true };
			}

			if (decimalPart && decimalPart.length > numbersAfterPoint) {
				return { valid: false };
			}

			return { valid: true };
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/helpers/validation.service.ts